import { computed, getCurrentInstance } from "vue";

export function useTableConfig(viewState) {
  const store = getCurrentInstance()?.proxy?.$store;

  const tableParams = computed(() => ({
    headers: [
      {
        text: "Employee",
        sortable: true,
        value: "employee",
        width: "200px",
      },
      {
        text: "Readiness",
        sortable: true,
        value: "readiness",
        width: "220px",
      },
      {
        text: "Badges",
        sortable: true,
        value: "badges",
        width: "200px",
      },
      {
        text: "Readiness Map",
        sortable: false,
        value: "readinessMap",
        width: "320px",
      },
    ],
    columns: [
      {
        field: "",
        component: "EmployeeCard",
        props: (item) => ({
          class: "my-4",
          ...viewState.getEmployeeCardProps(item),
        }),
        events: () => ({}),
      },
      {
        field: "",
        component: "ReadinessBar",
        props: (item) => ({
          class: "my-4",
          ...viewState.getReadinessBarProps(item),
        }),
      },
      {
        field: "",
        component: "EmployeeBadgeCounter",
        props: (item) => ({
          class: "my-4",
          ...viewState.getEmployeeBadgeCounterProps(item),
        }),
        events: (item) => ({
          click: () => {
            if (!store?.getters?.["featureFlags/ideaMDP442"]) return;
            viewState.onClickBadgeCounter(item);
          },
        }),
      },
      {
        field: "",
        component: "ReadinessMapButton",
        props: (item) => ({
          class: "my-4",
          ...viewState.getReadinessMapButtonProps(item),
        }),
        events: (item) => ({
          click: () => {
            if (!store?.getters?.["featureFlags/ideaMDP442"]) return;
            viewState.onClickReadinessMap(item);
          },
        }),
      },
    ],
    filters: {
      values: viewState.state.filters.values,
      searchText: viewState.state.filters.searchText,
      searchGhostText: "Search Employee",
    },
    hideTopSection: true,
    hideActiveNo: false,
    activeRecords: {
      field: "current_status",
      value: "active",
    },
    showActionButton: true,
    hideGridView: true,
    hideButtonIcon: true,
    title: "Employees Readiness",
    hideButtonInMessage: true,
    hideFilterBtn: false,
  }));

  return {
    tableParams,
  };
}
